export default __webpack_public_path__ + "static/media/GitmusicThumb.d55495cd.png";